import { Site, Category, Manufacturer, WorkOrder, WorkOrderEstimate, Customer, IntakeLine, Asset } from '@/types/models';

export const MOCK_SITES: Site[] = [
  { id: 'phoenix', name: 'Phoenix, AZ', address: '123 Industrial Blvd', city: 'Phoenix', state: 'AZ', is_active: true },
  { id: 'denver', name: 'Denver, CO', address: '456 Tech Park Dr', city: 'Denver', state: 'CO', is_active: true },
  { id: 'dallas', name: 'Dallas, TX', address: '789 Commerce St', city: 'Dallas', state: 'TX', is_active: true },
];

/** @deprecated Use MOCK_SITES */
export const MOCK_LOCATIONS = MOCK_SITES;

export let MOCK_CATEGORIES: Category[] = [
  { id: 'laptops', name: 'Laptops', is_active: true },
  { id: 'desktops', name: 'Desktops', is_active: true },
  { id: 'servers', name: 'Servers', is_active: true },
  { id: 'monitors', name: 'Monitors', is_active: true },
  { id: 'switches', name: 'Switches/Routers', is_active: true },
  { id: 'routers', name: 'Routers', is_active: true },
  { id: 'phones', name: 'Mobile Devices', is_active: true },
  { id: 'printers', name: 'Printers', is_active: true },
  { id: 'storage', name: 'Storage Devices', is_active: true },
  { id: 'cables', name: 'Cables', is_active: true },
  { id: 'peripherals', name: 'Peripherals', is_active: true },
  { id: 'mixed', name: 'Mixed Electronics', is_active: true },
  { id: 'scrap', name: 'Scrap Electronics', is_active: true },
  { id: 'misc', name: 'Miscellaneous', is_active: true },
];

export let MOCK_MANUFACTURERS: Manufacturer[] = [
  { id: 'dell', name: 'Dell', is_active: true },
  { id: 'hp', name: 'HP', is_active: true },
  { id: 'lenovo', name: 'Lenovo', is_active: true },
  { id: 'apple', name: 'Apple', is_active: true },
  { id: 'cisco', name: 'Cisco', is_active: true },
  { id: 'samsung', name: 'Samsung', is_active: true },
  { id: 'asus', name: 'Asus', is_active: true },
  { id: 'lg', name: 'LG', is_active: true },
  { id: 'microsoft', name: 'Microsoft', is_active: true },
  { id: 'other', name: 'Other', is_active: true },
];

export const MOCK_CUSTOMERS: Customer[] = [
  { id: 'cust1', name: 'Acme Corp', company: 'Acme Corp', is_active: true },
  { id: 'cust2', name: 'TechStart Inc', company: 'TechStart Inc', is_active: true },
  { id: 'cust3', name: 'MegaCo LLC', company: 'MegaCo LLC', is_active: true },
  { id: 'cust4', name: 'GlobalTech', company: 'GlobalTech', is_active: true },
];

export let MOCK_WORK_ORDERS: WorkOrder[] = [
  {
    id: 'wo1', work_order_number: 'WO-2026-001', customer_id: 'cust1', customer_name: 'Acme Corp', company: 'Acme Corp',
    phone: '555-0101', email: 'john@acme.com', work_order_type: 'pickup', ownership_model: 'recycler_owned',
    status: 'in_progress', site_id: 'phoenix', scheduled_date: '2026-03-06', assigned_operator: 'Op1',
    assets_received: 45, assets_processed: 12, created_at: '2026-03-01T10:00:00Z', updated_at: '2026-03-06T14:00:00Z',
    driver: 'Mike R.', vehicle: 'Truck #3', pickup_address: '100 Main St, Phoenix AZ',
  },
  {
    id: 'wo2', work_order_number: 'WO-2026-002', customer_id: 'cust2', customer_name: 'TechStart Inc', company: 'TechStart Inc',
    phone: '555-0102', email: 'sarah@techstart.com', work_order_type: 'dropoff', ownership_model: 'customer_owned',
    status: 'scheduled', site_id: 'phoenix', scheduled_date: '2026-03-08', assigned_operator: 'Op2',
    assets_received: 0, assets_processed: 0, created_at: '2026-03-04T09:00:00Z', updated_at: '2026-03-04T09:00:00Z',
  },
  {
    id: 'wo3', work_order_number: 'WO-2026-003', customer_id: 'cust3', customer_name: 'MegaCo LLC', company: 'MegaCo LLC',
    phone: '555-0103', email: 'mike@megaco.com', work_order_type: 'pickup', ownership_model: 'recycler_owned',
    status: 'completed', site_id: 'denver', scheduled_date: '2026-02-28', assigned_operator: 'Op1',
    assets_received: 120, assets_processed: 120, created_at: '2026-02-20T08:00:00Z', updated_at: '2026-03-02T16:00:00Z',
    driver: 'Alex T.', vehicle: 'Truck #1', pickup_address: '500 Industrial Way, Denver CO',
  },
  {
    id: 'wo4', work_order_number: 'WO-2026-004', customer_id: 'cust4', customer_name: 'GlobalTech', company: 'GlobalTech',
    phone: '555-0104', email: 'lisa@globaltech.com', work_order_type: 'dropoff', ownership_model: 'customer_owned',
    status: 'intake_complete', site_id: 'dallas', scheduled_date: '2026-03-05', assigned_operator: 'Op3',
    assets_received: 78, assets_processed: 30, created_at: '2026-03-03T11:00:00Z', updated_at: '2026-03-06T10:00:00Z',
  },
  {
    id: 'wo5', work_order_number: 'WO-2026-005', customer_id: 'cust1', customer_name: 'Acme Corp', company: 'Acme Corp',
    phone: '555-0101', email: 'john@acme.com', work_order_type: 'pickup', ownership_model: 'recycler_owned',
    status: 'processing', site_id: 'phoenix', scheduled_date: '2026-03-04', assigned_operator: 'Op2',
    assets_received: 200, assets_processed: 85, created_at: '2026-02-28T14:00:00Z', updated_at: '2026-03-06T12:00:00Z',
    driver: 'Mike R.', vehicle: 'Truck #3', pickup_address: '100 Main St, Phoenix AZ',
  },
  {
    id: 'wo6', work_order_number: 'WO-2026-006', customer_id: 'cust2', customer_name: 'TechStart Inc', company: 'TechStart Inc',
    phone: '555-0102', email: 'sarah@techstart.com', work_order_type: 'dropoff', ownership_model: 'recycler_owned',
    status: 'cancelled', site_id: 'denver', scheduled_date: '2026-03-01',
    assets_received: 0, assets_processed: 0, created_at: '2026-02-25T10:00:00Z', updated_at: '2026-02-27T09:00:00Z',
    notes: 'Customer cancelled — rescheduling for next month',
  },
];

// ==================== Intake Lines ====================

export let MOCK_INTAKE_LINES: IntakeLine[] = [
  { id: 'il1', work_order_id: 'wo1', category_id: 'laptops', category_name: 'Laptops', intake_mode: 'detailed', quantity_total: 20, quantity_serialized: 8, quantity_remaining: 12 },
  { id: 'il2', work_order_id: 'wo1', category_id: 'desktops', category_name: 'Desktops', intake_mode: 'bulk', quantity_total: 25, quantity_serialized: 4, quantity_remaining: 21 },
  { id: 'il3', work_order_id: 'wo4', category_id: 'switches', category_name: 'Switches/Routers', intake_mode: 'detailed', quantity_total: 30, quantity_serialized: 15, quantity_remaining: 15 },
  { id: 'il4', work_order_id: 'wo5', category_id: 'laptops', category_name: 'Laptops', intake_mode: 'detailed', quantity_total: 100, quantity_serialized: 45, quantity_remaining: 55 },
  { id: 'il5', work_order_id: 'wo5', category_id: 'phones', category_name: 'Mobile Devices', intake_mode: 'bulk', quantity_total: 100, quantity_serialized: 40, quantity_remaining: 60 },
];

// ==================== Work Order Estimates ====================

export const MOCK_ESTIMATES: WorkOrderEstimate[] = [
  { id: 'est1', work_order_id: 'wo1', category_id: 'laptops', category_name: 'Laptops', quantity: 20 },
  { id: 'est2', work_order_id: 'wo1', category_id: 'desktops', category_name: 'Desktops', quantity: 25 },
  { id: 'est3', work_order_id: 'wo4', category_id: 'switches', category_name: 'Switches/Routers', quantity: 30 },
  { id: 'est4', work_order_id: 'wo5', category_id: 'laptops', category_name: 'Laptops', quantity: 100 },
  { id: 'est5', work_order_id: 'wo5', category_id: 'phones', category_name: 'Mobile Devices', quantity: 100 },
  { id: 'est6', work_order_id: 'wo7', category_id: 'laptops', category_name: 'Laptops', quantity: 50 },
  { id: 'est7', work_order_id: 'wo7', category_id: 'monitors', category_name: 'Monitors', quantity: 30 },
];

// ==================== Mock Helpers ====================

let woCounter = 7;
let assetCounter = 6;
let ilCounter = 6;

export function createMockWorkOrder(data: Omit<WorkOrder, 'id' | 'work_order_number' | 'assets_received' | 'assets_processed' | 'created_at' | 'updated_at'>): WorkOrder {
  const now = new Date().toISOString();
  const wo: WorkOrder = {
    ...data,
    id: `wo${woCounter}`,
    work_order_number: `WO-2026-${String(woCounter).padStart(3, '0')}`,
    assets_received: 0,
    assets_processed: 0,
    created_at: now,
    updated_at: now,
  };
  woCounter++;
  MOCK_WORK_ORDERS = [wo, ...MOCK_WORK_ORDERS];
  return wo;
}

export function createMockAsset(data: Omit<Asset, 'id' | 'internal_barcode' | 'created_at' | 'updated_at'>): Asset {
  const now = new Date().toISOString();
  const asset: Asset = {
    ...data,
    id: `a${assetCounter}`,
    internal_barcode: `ET${String(assetCounter).padStart(6, '0')}`,
    created_at: now,
    updated_at: now,
  };
  assetCounter++;
  return asset;
}

export function addMockIntakeLine(data: Omit<IntakeLine, 'id'>): IntakeLine {
  const line: IntakeLine = {
    ...data,
    id: `il${ilCounter}`,
  };
  ilCounter++;
  MOCK_INTAKE_LINES = [...MOCK_INTAKE_LINES, line];
  return line;
}